import Game from '../game/Game'
export const NEW_GAME = 'NEW_GAME'
export const SELECT_ROBOT = 'SELECT_ROBOT'
export const MOVE_ROBOT = 'MOVE_ROBOT'
export const DESELECT_ROBOT = 'DESELECT_ROBOT'
export const LOAD_STATE = 'LOAD_STATE'
export const LOAD_GOAL = 'LOAD_GOAL'
export const RECEIVE_HIGHSCORES = 'RECEIVE_HIGHSCORES'
export const SELECT_HIGHSCORE = 'SELECT_HIGHSCORE'
export const SET_NEXT_CHALLENGE_TIME = 'SET_NEXT_CHALLENGE_TIME'

function noAction() {
  return {
    type: "NOTHING" //doesnt do anything
  }
}

export function fetchChallenge(){
 return dispatch => {
   //dispatch(requestPosts())
   return fetch('/challenge/config')
     .then(response => response.json())
     .then(json => dispatch(newGame(json)))
 }
}

export function fetchOldChallenge(){
 return dispatch => {
   //dispatch(requestPosts())
   return fetch('/challenge/lastconfig')
     .then(response => response.json())
     .then(json => dispatch(newGame(json, true)))
 }
}

export function fetchNextChallengeTime(){
  return dispatch => {
    //dispatch(requestPosts())
    return fetch('/challenge/nextconfigtime')
      .then(response => response.json())
      .then(json => {
        if (json !== null) {
          dispatch({
            type: SET_NEXT_CHALLENGE_TIME,
            time: new Date(json)
          })
        }
      })
  }
}

export function fetchHighscores(){
  return dispatch => {
    //dispatch(requestPosts())
    return fetch('/challenge/highscores')
      .then(response => response.json())
      .then(json => dispatch(receiveHighscores(json)))
  }
}

function receiveHighscores(json){
  return {
    type: RECEIVE_HIGHSCORES,
    scores: json
  }
}

export function selectHighscore(score) {
  return {
    type: SELECT_HIGHSCORE,
    challengeId: score.challengeId,
    name: score.name
  }
}

export function submitChallenge(name){
  let payload = Game.logInstance.getChallengeSolutions()
  payload.name = name
  fetch('/challenge/submission', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  return noAction()
}

export function newGame(data, isOldChallenge) {
  let board, robots
  //need to fetch challenge board and robot
  //test data
  // data = { 
  //   "challengeId": 58,
  //   "config": "30303231",
  //   "robots": [[11,14,"yellow"],[2,12,"green"],[4,8,"red"],[3,1,"blue"]],
  //   "goals": [[9,0,"yellow"],[12,9,"blue"],[15,11,"blue"],[13,4,"red"],[2,1,"green"]]   
  // }
  if(data){
    board = Game.newBoard(data, isOldChallenge)
    robots = Game.getRobots()
  } else {
    board = Game.newBoard()
    robots = Game.newRobots()
  }
  return {
    type: NEW_GAME,
    board: board,
    robots: robots,
    goal: Game.goal.slice(),
    goalColor: Game.goalColor,
    config: Game.boardInstance.config
  }
}

export function selectRobot(color) {
  return {
    type: SELECT_ROBOT,
    activeColor: color
  }
}

export function deselectRobot() {
  return {
    type: DESELECT_ROBOT,
  }
}

export function loadState(state) {
  Game.loadState(state)
  return {
    type: LOAD_STATE,
    goal: Game.goal.slice(),
    goalColor: Game.goalColor,
    robots: Game.getRobots(),
  }
}

export function loadGoal(state) {
  Game.loadGoal(state)
  return {
    type: LOAD_GOAL,
    goal: Game.goal.slice(),
    goalColor: Game.goalColor,
  }
}

export function nextRobot(color){
  //if no active color, use the goal color, otherwise rotate to next color
  if(!color){
    color = Game.goalColor
  } else {
    var index = (Game.robotColors.indexOf(color)+1)%(Game.robotColors.length)
    color = Game.robotColors[index]
  }
  return {
    type: SELECT_ROBOT,
    activeColor: color
  }
}

export function moveRobot(color, direction){
  let moveResult = Game.moveRobot(color, direction);
  if (moveResult.moved === false) return noAction()
  let robots = Game.getRobots(),
      goal,
      goalColor,
      solution = Game.solution;

  if(moveResult.targetReached){
    ga('send', {
      hitType: 'event',
      eventCategory: 'Game',
      eventAction: 'GoalReached',
      eventLabel: Game.isChallenge ? 'Challenge' : 'Classic'
    })
    Game.isChallenge ? Game.nextChallengeGoal() : Game.newGoal()
    goal = Game.goal.slice()
    goalColor = Game.goalColor
    robots = Game.isChallenge? Game.newChallengeRobots() : Game.getRobots()
  }
  return {
    type: MOVE_ROBOT,
    targetReached: moveResult.targetReached,
    robots: robots,
    goal: goal,
    goalColor: goalColor,
    solution: solution
  }
}



// WEBPACK FOOTER //
// ./actions/game.js